// extracted by mini-css-extract-plugin
export default {"title":"AddressInformation_title__C8FkY","group":"AddressInformation_group__wm5S2","field":"AddressInformation_field__LMNtN"};